function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero",
  stroke: "#858585",
  fill: "none",
  opacity: 0.17
}, React.createElement("path", {
  d: "M4.5 0v4M4.5 5v4M9 4.5H0"
}));

var SvgPlusPattern = function SvgPlusPattern(props) {
  return React.createElement("svg", _extends({
    width: 43,
    height: 43
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDNweCIgaGVpZ2h0PSI0M3B4IiB2aWV3Qm94PSIwIDAgNDMgNDMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjIgKDU3NTE5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5wbHVzLXBhdHRlcm48L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjE3Ij4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSIjODU4NTg1Ij4KICAgICAgICAgICAgPHBhdGggZD0iTTQuNSwwIEw0LjUsNCIgaWQ9IkxpbmUiPjwvcGF0aD4KICAgICAgICAgICAgPHBhdGggZD0iTTQuNSw1IEw0LjUsOSIgaWQ9IkxpbmUiPjwvcGF0aD4KICAgICAgICAgICAgPHBhdGggZD0iTTksNC41IEwwLDQuNSIgaWQ9IkxpbmUiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgPlusPattern as ReactComponent };